export default "__VITE_ASSET__CgnRDUov__"